import { metaSort } from '@/router'

export const helperAssignChild = (path, child, target) => {
  let belongChild
  path.forEach((v, i) => {
    if (i === 0) {
      belongChild = target.find(k => k.name === v)
    } else {
      belongChild = belongChild.children.find(k => k.name === v)
    }
  })
  belongChild.children.push(child)
  // shit
  belongChild.children.sort(metaSort)
}
